import { Play } from "lucide-react";
import { useState } from "react";

interface ExchangeVideoGuideProps {
  exchange: string;
}

const ExchangeVideoGuide = ({ exchange }: ExchangeVideoGuideProps) => {
  const [showVideo, setShowVideo] = useState(false);

  const [isHovered, setIsHovered] = useState(false);

  const handlePlay = () => setShowVideo(true);

  const getVideoId = () => {
    switch (exchange.toLowerCase()) {
      case 'bybit':
        return 'PsyUUIey6P8';
      case 'phemex':
        return '8kgs-9Vvdn4';
      case 'okx':
        return 'EOv2OBWKOCI';
      default:
        return null;
    }
  };

  const videoId = getVideoId();
  
  if (!videoId) return null;

  return (
    <div className="mt-8">
        <h4 className="font-semibold text-lg mb-3">How to trade in {exchange}:</h4>
      <div className="relative w-full">
        {!showVideo ? (
          <div
          className="rounded-full bg-gradient-to-br from-[#FF3B3B] to-[#D72631] flex items-center justify-center cursor-pointer w-24 h-24 shadow-lg mx-auto transform transition-transform duration-300 hover:scale-110"
          onClick={handlePlay}
        >
            <Play className="text-white w-12 h-12" />
          </div>
        ) : (
          <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
            <iframe
              className="absolute top-0 left-0 w-full h-full rounded-lg"
              src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ExchangeVideoGuide;
